const paintings1 = [
  {
    id: '1_01',
    name: 'Stag Hunt',
    imageSrc: 'level1/deerhunt.jpg',
    cutSrc: 'level1/cut/deerhunt.jpg',
    author: "Niccolò dell'",
    year: '1550-52',
  },
  {
    id: '1_02',
    name: 'Deer beside a Lake',
    imageSrc: 'level1/deerlake.jpg',
    cutSrc: 'level1/cut/deerlake.jpg',
    author: 'Carl Frederik',
    year: '1888',
  },
  {
    id: '1_03',
    name: 'Country Road with Cypresses',
    imageSrc: 'level1/abbati2.jpg',
    cutSrc: 'level1/cut/abbati2.jpg',
    author: 'ABBATI, Giuseppe',
    year: '1860',
  },
  {
    id: '1_04',
    name: 'Fireworks in Naples',
    imageSrc: 'level1/firework.jpg',
    cutSrc: 'level1/cut/firework.jpg',
    author: 'ACHENBACH, Oswald',
    year: '1875',
  },
  {
    id: '1_05',
    name: 'The Ninth Wave',
    imageSrc: 'level1/9th_wave.jpg',
    cutSrc: 'level1/cut/9th_wave.jpg',
    author: 'AIVAZOVSKY, Ivan Konstantinovich',
    year: '1850',
  },
  {
    id: '1_06',
    name: 'View of Campo Santi Giovanni e Paolo',
    imageSrc: 'level1/campo.jpg',
    cutSrc: 'level1/cut/campo.jpg',
    author: 'ALBOTTO, Francesco',
    year: '1745',
  },
  {
    id: '1_07',
    name: 'San Giuseppe di Castello',
    imageSrc: 'level1/giuseppe.jpg',
    cutSrc: 'level1/cut/giuseppe.jpg',
    author: 'ALBOTTO, Francesco',
    year: '1745',
  },
  {
    id: '1_08',
    name: 'View of St.Petersburg',
    imageSrc: 'level1/view_stp.jpg',
    cutSrc: 'level1/cut/view_stp.jpg',
    author: 'ALEKSEYEV, Fyodor Yakovlevich',
    year: '1795',
  },
  {
    id: '1_09',
    name: 'Landscape with the Finding of Moses',
    imageSrc: 'level1/landmose.jpg',
    cutSrc: 'level1/cut/landmose.jpg',
    author: 'ALLEGRAIN, Etienne',
    year: 'second half of XVII century',
  },
  {
    id: '1_10',
    name: 'River Landscape',
    imageSrc: 'level1/riverla2.jpg',
    cutSrc: 'level1/cut/riverla2.jpg',
    author: 'ALLEGRAIN, Etienne',
    year: 'second half of XVII century',
  },
  {
    id: '1_11',
    name: 'Extensive Wooded Landscape with Cephalus and Procris',
    imageSrc: 'level1/extensiv.jpg',
    cutSrc: 'level1/cut/extensiv.jpg',
    author: 'ALSLOOT, Denis van',
    year: 'first half of XVII century',
  },
  {
    id: '1_12',
    name: 'Skating during Carnival',
    imageSrc: 'level1/skating.jpg',
    cutSrc: 'level1/cut/skating.jpg',
    author: 'ALSLOOT, Denis van',
    year: '1620',
  },
  {
    id: '1_13',
    name: 'Winter Landscape',
    imageSrc: 'level1/winter_l.jpg',
    cutSrc: 'level1/cut/winter_l.jpg',
    author: 'ALSLOOT, Denis van',
    year: '1610',
  },
  {
    id: '1_14',
    name: 'Winter Landscape in the Fôret de Soignes, with the Flight Into Egypt',
    imageSrc: 'level1/winterla.jpg',
    cutSrc: 'level1/cut/winterla.jpg',
    author: 'ALSLOOT, Denis van',
    year: '1616',
  },
  {
    id: '1_15',
    name: 'View of Vienna from the Prater',
    imageSrc: 'level1/viewvien.jpg',
    cutSrc: 'level1/cut/viewvien.jpg',
    author: 'ALT, Rudolf von',
    year: '1834',
  },
  {
    id: '1_16',
    name: 'An English 3rd - Rate Ship of the Line in Three Positions',
    imageSrc: 'level1/rateship.jpg',
    cutSrc: 'level1/cut/rateship.jpg',
    author: 'ANDERSON, William',
    year: 'first half of XIX century',
  },
  {
    id: '1_17',
    name: 'Shipping in a Calm Sea off the Coast',
    imageSrc: 'level1/shipcalm.jpg',
    cutSrc: 'level1/cut/shipcalm.jpg',
    author: 'ANDERSON, William',
    year: '1803',
  },
  {
    id: '1_18',
    name: 'Shipping on the Thames off Deptford',
    imageSrc: 'level1/shipping.jpg',
    cutSrc: 'level1/cut/shipping.jpg',
    author: 'ANDERSON, William',
    year: '1825',
  },
  {
    id: '1_19',
    name: 'Italianate Coastal Landscape',
    imageSrc: 'level1/landsca3.jpg',
    cutSrc: 'level1/cut/landsca3.jpg',
    author: 'ANESI, Paolo',
    year: 'XVIII century',
  },
  {
    id: '1_20',
    name: 'Tiber Bridge in Rome',
    imageSrc: 'level1/rome.jpg',
    cutSrc: 'level1/cut/rome.jpg',
    author: 'ANESI, Paolo',
    year: 'XVIII century',
  },
  {
    id: '1_21',
    name: 'View of the Roman Campagna',
    imageSrc: 'level1/rome1.jpg',
    cutSrc: 'level1/cut/rome1.jpg',
    author: 'ANESI, Paolo',
    year: 'XVIII century',
  },
  {
    id: '1_22',
    name: 'Harbour Scene',
    imageSrc: 'level1/scene.jpg',
    cutSrc: 'level1/cut/scene.jpg',
    author: 'ANESI, Paolo',
    year: 'XVIII century',
  },
  {
    id: '1_23',
    name: 'View of Tivoli and the Roman Campagna',
    imageSrc: 'level1/tivoli.jpg',
    cutSrc: 'level1/cut/tivoli.jpg',
    author: 'ANESI, Paolo',
    year: 'XVIII century',
  },
  {
    id: '1_24',
    name: 'The Western Railway Leaving Paris',
    imageSrc: 'level1/railway.jpg',
    cutSrc: 'level1/cut/railway.jpg',
    author: 'ANGRAND, Charles',
    year: '1886',
  },
  {
    id: '1_25',
    name: 'Landscape with a Musician',
    imageSrc: 'level1/landscap.jpg',
    cutSrc: 'level1/cut/landscap.jpg',
    author: 'APSHOVEN, Thomas van',
    year: 'XVII century',
  },
  {
    id: '1_26',
    name: 'Edge of a Wood',
    imageSrc: 'level1/edgewood.jpg',
    cutSrc: 'level1/cut/edgewood.jpg',
    author: "ARTHOIS, Jacques d'",
    year: 'XVII century',
  },
  {
    id: '1_27',
    name: 'An Extensive Wooded Landscape with Travellers on a Path',
    imageSrc: 'level1/extensiv_1.jpg',
    cutSrc: 'level1/cut/extensiv_1.jpg',
    author: "ARTHOIS, Jacques d'",
    year: 'XVII century',
  },
  {
    id: '1_28',
    name: 'Wooded Landscape',
    imageSrc: 'level1/landscap_1.jpg',
    cutSrc: 'level1/cut/landscap_1.jpg',
    author: "ARTHOIS, Jacques d'",
    year: 'XVII century',
  },
  {
    id: '1_29',
    name: 'Wooded Landscape',
    imageSrc: 'level1/woodedla.jpg',
    cutSrc: 'level1/cut/woodedla.jpg',
    author: "ARTHOIS, Jacques d'",
    year: 'XVII century',
  },
  {
    id: '1_30',
    name: 'The Delft City Wall with the Houttuinen',
    imageSrc: 'level1/citywall.jpg',
    cutSrc: 'level1/cut/citywall.jpg',
    author: 'ASCH, Pieter Jansz.van',
    year: '1650',
  },
  {
    id: '1_31',
    name: 'River Landscape',
    imageSrc: 'level1/river_la.jpg',
    cutSrc: 'level1/cut/river_la.jpg',
    author: 'ASCH, Pieter Jansz. van',
    year: '1640',
  },
  {
    id: '1_32',
    name: 'View of Killarney',
    imageSrc: 'level1/kilarney.jpg',
    cutSrc: 'level1/cut/kilarney.jpg',
    author: 'ASHFORD, William',
    year: '1778',
  },
  {
    id: '1_33',
    name: 'Landscape with Waterfall and Farm',
    imageSrc: 'level1/waterfal.jpg',
    cutSrc: 'level1/cut/waterfal.jpg',
    author: 'ASSCHE, Henri van',
    year: '1806',
  },
  {
    id: '1_34',
    name: 'Winter Landscape',
    imageSrc: 'level1/winterla_1.jpg',
    cutSrc: 'level1/cut/winterla_1.jpg',
    author: 'ASSCHE, Henri van',
    year: '1814',
  },
  {
    id: '1_35',
    name: 'Coastal Scene with Resting Riders',
    imageSrc: 'level1/coastal.jpg',
    cutSrc: 'level1/cut/coastal.jpg',
    author: 'ASSELYN, Jan',
    year: '1652',
  },
  {
    id: '1_36',
    name: 'Italianate Landscape with a River and an Arched Bridge',
    imageSrc: 'level1/italiana.jpg',
    cutSrc: 'level1/cut/italiana.jpg',
    author: 'ASSELYN, Jan',
    year: '1648',
  },
  {
    id: '1_37',
    name: 'Italianate Landscape with Peasants and Animals Fording a River',
    imageSrc: 'level1/italianb.jpg',
    cutSrc: 'level1/cut/italianb.jpg',
    author: 'ASSELYN, Jan',
    year: '1640-45',
  },
  {
    id: '1_38',
    name: 'Landscape with Frozen River',
    imageSrc: 'level1/landscap_2.jpg',
    cutSrc: 'level1/cut/landscap_2.jpg',
    author: 'AVERCAMP, Barend',
    year: '1655',
  },
  {
    id: '1_39',
    name: 'Ice Landscape',
    imageSrc: 'level1/ice_land.jpg',
    cutSrc: 'level1/cut/ice_land.jpg',
    author: 'AVERCAMP, Hendrick',
    year: 'XVII century',
  },
  {
    id: '1_40',
    name: 'Arabs on Horseback',
    imageSrc: 'level1/arabs.jpg',
    cutSrc: 'level1/cut/arabs.jpg',
    author: "AZEGLIO, Massimo Taparelli, Marquis d'",
    year: '1840',
  },
  {
    id: '1_41',
    name: 'Ships in Distress off a Rocky Coast',
    imageSrc: 'level1/distress.jpg',
    cutSrc: 'level1/cut/distress.jpg',
    author: 'BACKHUYSEN, Ludolf',
    year: '1667',
  },
  {
    id: '1_42',
    name: 'A Fishing Pink',
    imageSrc: 'level1/fishing.jpg',
    cutSrc: 'level1/cut/fishing.jpg',
    author: 'BACKHUYSEN, Ludolf',
    year: '1680',
  },
  {
    id: '1_43',
    name: 'Shipping by the Dutch Coast',
    imageSrc: 'level1/shipping_1.jpg',
    cutSrc: 'level1/cut/shipping_1.jpg',
    author: 'BACKHUYSEN, Ludolf',
    year: 'XVII century',
  },
  {
    id: '1_44',
    name: 'View from the Nieuwe Maas River towards the City of Vlaardingen',
    imageSrc: 'level1/viewvlaa.jpg',
    cutSrc: 'level1/cut/viewvlaa.jpg',
    author: 'BACKHUYSEN, Ludolf',
    year: '1680s',
  },
  {
    id: '1_45',
    name: 'Dutch Vessels off a Coastline on a Breezy Day',
    imageSrc: 'level1/vessels1.jpg',
    cutSrc: 'level1/cut/vessels1.jpg',
    author: 'BACKHUYSEN, Ludolf',
    year: '1680',
  },
];

export default paintings1;
